/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GetWhitelistFileQuery = {
    format: GetWhitelistFileQuery.format;
    samId: string;
    fileName: string;
    fileOffset: number;
    fileBufferLength: number;
};
export namespace GetWhitelistFileQuery {
    export enum format {
        ABSOLUTE = 'Absolute',
        DELTA = 'Delta',
        ABSOLUTE_WITHOUT_PERSONAL_DATA = 'AbsoluteWithoutPersonalData',
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
    }
}

